import { AdminRoute } from '/@/modules/admin/constants/AdminRoute';
import { AdminRouteConfig } from '/@/modules/admin/routes/AdminRouteConfig';
import { AnnouncementManagementRouteConfig } from '@/modules/admin/routes/AnnouncementManagementRouteConfig';

export const router = AdminRouteConfig.factory([
  {
    name: AdminRoute.ADMINPAGE,
    path: `/${AdminRoute.ADMINPAGE}`,
    component: () => import('/@/modules/admin/pages/AdminPage.vue'),
    children: [
      {
        path: `/${AdminRoute.ADMINPANEL}`,
        name: AdminRoute.ADMINPANEL,
        component: () => import('/@/modules/admin/pages/AdministrationPage.vue')
      },
      {
        path: `/${AdminRoute.LOCALIZATION}`,
        name: AdminRoute.LOCALIZATION,
        component: () => import('/@/modules/admin/pages/LocalizationPage.vue')
      },
      {
        path: `/${AdminRoute.EMAILTEMPLATES}`,
        name: AdminRoute.EMAILTEMPLATES,
        component: () => import('/@/modules/admin/pages/EmailTemplatesPage.vue')
      },
      {
        path: `/${AdminRoute.PERMISSIONS_SETS}`,
        name: AdminRoute.PERMISSIONS_SETS,
        component: () => import('/@/modules/permission/pages/PermissionSetPage.vue')
      },
      {
        path: `/${AdminRoute.AI_TOOLS}`,
        name: AdminRoute.AI_TOOLS,
        component: () => import('/@/modules/admin/pages/AIToolsPage.vue')
      },
      {
        path: `/${AdminRoute.WORKFLOWS}`,
        name: AdminRoute.WORKFLOWS,
        component: () => import('/@/modules/admin/pages/WorkflowsPage.vue')
      },
      AnnouncementManagementRouteConfig.factory({
        path: `/${AdminRoute.ANNOUNCEMENT_MANAGEMENT}`,
        name: AdminRoute.ANNOUNCEMENT_MANAGEMENT,
        component: () => import('/@/modules/admin/pages/AnnouncementManagementPage.vue')
      }).build()
    ]
  },
  {
    path: `/${AdminRoute.FEATUREFLAGS}`,
    name: AdminRoute.FEATUREFLAGS,
    component: () => import('/@/modules/admin/pages/FeatureFlagsPage.vue'),
    meta: { authOnly: true }
  }
]).build();
